var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderBase',{attrs:{"logoLink":_vm.logoLink,"logoutTo":"/admin"},on:{"show-menu":_vm.showMenu},scopedSlots:_vm._u([{key:"menu",fn:function(){return [_vm._v(" 校舎:"+_vm._s(_vm.building)+" ")]},proxy:true}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }